import numberFormatter from "scripts/data_utils/number_formatter";
import onlyNumeric from "scripts/data_utils/only_numeric";

const mutateFromRange = ({
  inputValue,
  range
} = {}) => {
  const [min = 0, max = Number.MAX_SAFE_INTEGER] = range;
  let value = onlyNumeric(inputValue);

  if (range.length) {
    value = value > min ? value : min;
    value = value < max ? value : max;
  }

  return value;
};
/**
 * Number processor
 *
 * @param {string|number} inputValue
 * @param {object} options  - object of options for number processing
 * @param {Boolean} [removeNotNumeric = true]  - flag use for enable number normalize (use remove non digits symbols)
 * @param {number[]} [range = [min, max]]  - range for normalize number
 * @param {Boolean} [format = false]  - flag use for enable format number (use Intl API)
 * @returns {number}
 */


function numberProcessor({
  inputValue,
  options: {
    removeNotNumeric = true,
    range = [],
    format = false
  } = {}
}) {
  let value = inputValue;

  if (removeNotNumeric) {
    value = onlyNumeric(inputValue);
  }

  if (range && range.length === 2) {
    value = mutateFromRange({
      inputValue: value,
      range
    });
  }

  if (format) {
    value = numberFormatter(value);
  }

  return value;
}

export default numberProcessor;